import "./views.scss";

import { useEffect } from "react";

import { useFormFlowContext } from "../components/forms/FormFlowContext";
import LoadingBeacon from "../components/loading/LoadingBeacon";
import { Beacon } from "../components/svgs/beacon";
import { triggerCommunityRegistrationView } from "../helpers/observability/analytics";

/**
 * Submitting component displays a success message or a loading spinner based on the formSuccess prop.
 *
 * @param {Object} props - The component props.
 * @param {boolean} [props.visible=true] - Determines if the component should be visible.
 *
 * @returns {JSX.Element|null} The rendered Submitting.. or Creating your account... etc or null if not visible.
 */
const Submitting = (props) => {
  const { visible = true } = props;
  const { formSuccess, submittingMessage } = useFormFlowContext();

  useEffect(() => {
    if (formSuccess && visible) {
      const triggerOnce = true;
      triggerCommunityRegistrationView(
        {
          event_action: "registration_complete",
          event_label: "registration_success"
        },
        triggerOnce
      );
    }
  }, [formSuccess, visible]);

  if (!visible) {
    return null;
  }

  const SuccessInner = () => {
    return (
      <>
        <div className="display-flex justify-center">
          <h1 className="serif">
            <strong>Success!</strong>
          </h1>
        </div>
        <Beacon />
      </>
    );
  };

  const SubmittingInner = () => {
    return (
      <>
        <div className="header">
          <h1 className="serif">
            <strong>{submittingMessage}</strong>
          </h1>
        </div>
        <LoadingBeacon />
      </>
    );
  };

  return (
    <div className="views submission-container display-flex justify-center">
      <div className="display-grid gap-xs grid-rows-max">
        {formSuccess ? <SuccessInner /> : <SubmittingInner />}
      </div>
    </div>
  );
};

export default Submitting;
